var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "inner" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.checked,
          expression: "checked"
        }
      ],
      attrs: { type: "checkbox", name: _vm.name, id: _vm.id },
      domProps: {
        checked: _vm.check,
        checked: Array.isArray(_vm.checked)
          ? _vm._i(_vm.checked, null) > -1
          : _vm.checked
      },
      on: {
        change: [
          function($event) {
            var $$a = _vm.checked,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_vm.checked = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.checked = $$c
            }
          },
          _vm.handleChange
        ]
      }
    }),
    _vm._v(" "),
    _c(
      "label",
      {
        class: _vm.checked ? "reverse" : "",
        attrs: { for: _vm.id, id: "checkbox" }
      },
      [
        _c(
          "svg",
          {
            style: _vm.customStyle,
            attrs: {
              viewBox: "0 0 100 100",
              stroke: _vm.checked ? _vm.borderColorActive : _vm.borderColor
            }
          },
          [
            _c("path", {
              staticClass: "box",
              attrs: {
                fill: _vm.checked ? _vm.fillColorActive : _vm.fillColor,
                d:
                  "M82,89H18c-3.87,0-7-3.13-7-7V18c0-3.87,3.13-7,7-7h64c3.87,0,7,3.13,7,7v64C89,85.87,85.87,89,82,89z"
              }
            }),
            _vm._v(" "),
            _c("polyline", {
              staticClass: "check",
              attrs: { points: "25.5,53.5 39.5,67.5 72.5,34.5 " }
            })
          ]
        ),
        _vm._v(" "),
        _vm.text
          ? _c(
              "span",
              [
                _vm._t("default"),
                _vm._v("\n      " + _vm._s(_vm.text) + "\n    ")
              ],
              2
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52434162", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52434162","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/CheckBox.vue
// module id = null
// module chunks = 